import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputGoogleMap_container: {
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		},
		inputGoogleMap_map: {
			minHeight: '500px',
			margin: '8px 0px',
			'& > div > div': {
				borderRadius: theme.shape.borderRadius
			}
		},
		inputGoogleMap_mapError: {
			boxShadow: `0px 0px 6px 1px ${theme.palette.error.main}`
		},
		inputGoogleMap_helperTextWrapper: {
			display: 'flex',
		},
		inputGoogleMap_helperTextErrorIcon: {
			marginRight: '8px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		inputGoogleMap_helperText: {
			display: 'flex',
			alignItems: 'center',
		},
		inputGoogleMap_coordinateInputsContainer: {
			display: 'flex',
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				marginTop: theme.spacing(3),
				'& > div:first-child': {
					marginRight: theme.spacing(1.5),
				},
				'& > div:last-child': {
					marginLeft: theme.spacing(1.5),
				}
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				flexDirection: 'column',
				'& > div:first-child': {
					marginTop: theme.spacing(3),
				},
				'& > div:last-child': {
					margin: theme.spacing(3, 0),
				}
			},
		},
		inputGoogleMap_coordinateInputContainer: {
			display: 'flex',
			flexDirection: 'column',
			flex: '1 0',
		}
	});
});

export default useStyles;
